// eslint-disable-next-line no-use-before-define
import React, { useMemo, useRef } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";
import { HeaderMenuWrapper } from "./header-menu/HeaderMenuWrapper";
import { AnimateLoading } from "../../../_partials/controls";
import { useSelector } from "react-redux";
import { getBaseImageURL } from "../../../../helpers";

export function Header() {
  const uiService = useHtmlClassService();
  const { favIcon, siteName } = useSelector(
    (state) => state.settings?.generalSettings
  );
  const globalImagePath = useRef(getBaseImageURL());

  const fav = document.getElementById("favicon");

  if (!favIcon) {
    fav.setAttribute("href", "%PUBLIC_URL%/media/logos/favicon.ico");
  } else {
    fav.setAttribute("href", `${globalImagePath.current}${favIcon}`);
  }
  document.title = `Welcome to ${siteName}`;

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      ),
    };
  }, [uiService, favIcon]);

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
        >
          <AnimateLoading />
          {/*begin::Header Menu Wrapper*/}
          {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}

          {/*begin::Topbar*/}
          <Topbar />
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
